import React from 'react';
import './ToggleButton.scss';

interface ToggleButtonProps {
  children: React.ReactNode;
  onClick: () => any;
}

function ToggleButton({ children, onClick }: ToggleButtonProps) {
  return (
    <div className="outerLayer" onClick={onClick}>
      <div className="innerLayer">
        <b>{children}</b>
      </div>
    </div>
  );
}

export default ToggleButton;
